import { render, staticRenderFns } from "./QuestionFile.vue?vue&type=template&id=16bd81d6"
import script from "./QuestionFile.vue?vue&type=script&lang=js"
export * from "./QuestionFile.vue?vue&type=script&lang=js"
import style0 from "./QuestionFile.vue?vue&type=style&index=0&id=16bd81d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports